import { Component, inject, input, OnInit } from '@angular/core';
import { SelectComponent } from "../../select/select.component";
import { ISelectOption } from 'src/app/interfaces/components/select.interface';
import { TranslateModule } from '@ngx-translate/core';
import { PaymentMethodsService } from 'src/app/services/financial/payment-methods.service';

@Component({
  selector: 'app-payment-methods-select',
  standalone: true,
  imports: [
    SelectComponent,
    TranslateModule,
  ],
  templateUrl: './payment-methods-select.component.html'
})
export class PaymentMethodsSelectComponent implements OnInit {
  private readonly paymentMethodsService = inject(PaymentMethodsService);

  control = input.required<any>();
  paymentMethodsOptions: ISelectOption[] = [];
  page = 1;
  totalPages = 0;

  ngOnInit(): void {
    this.getPaymentMethods();
  }

  handlePaginationChange(event?: string) {
    this.page = this.page + 1;
    this.getPaymentMethods(event);
  }

  getPaymentMethods(event?: string) {
    if (event) {
      this.page = 1;
    }

    this.paymentMethodsService.getBySelect({
      pageSize: 5,
      page: this.page,
      searchText: event,
    }).subscribe((res) => {
      const data = res.items.map((item) => {
        return {
          value: item.id,
          label: item.name,
        };
      });

      this.totalPages = res.totalPages;

      if (this.page === 1) {
        this.paymentMethodsOptions = data;
      } else {
        this.paymentMethodsOptions = [...this.paymentMethodsOptions, ...data];
      }
    });
  }
}
